import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Container = styled.div`
  margin-top: ${(props) => props.theme.spacing?.md ?? '12px'};
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Header = styled.button`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.xs ?? '4px'};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? '14px'};
  color: var(--color-primary, ${(props) => props.theme.colors?.primary ?? '#2563eb'});
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: ${(props) => props.theme.spacing?.sm ?? '8px'} 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.xs ?? '4px'};
`;

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing?.sm ?? '8px'};
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? '14px'};
`;

export const Index = styled.span`
  flex-shrink: 0;
  color: var(--color-body-muted, #666);
  font-weight: 500;
`;

export const Link = styled.a`
  color: var(--color-primary, ${(props) => props.theme.colors?.primary ?? '#2563eb'});
  text-decoration: none;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }
`;
